import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getStockItemStatus = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/stock-item-status`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stock-item-status:", error.response?.data || error);
    throw error;
  }
};

export const getStockItemStatusById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/stock-item-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stock-item-status:", error.response?.data || error);
    throw error;
  }
};

export const createStockItemStatus = async (stockItemStatusData) => {
  try {
    const response = await axiosInstance.post(
      `${API_URL}/stock-item-status`,
      stockItemStatusData,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating stock-item-status:", error.response?.data || error);
    throw error;
  }
};

export const updateStockItemStatus = async (id, stockItemStatusData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/stock-item-status/${id}`,
      stockItemStatusData,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating stock-item-status:", error.response?.data || error);
    throw error;
  }
};

export const deleteStockItemStatus = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/stock-item-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting stock-item-status:", error.response?.data || error);
    throw error;
  }
};
